var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-565"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "32.12 402.62 32.12 443.57 92.01 443.57 158.06 443.57 158.06 402.62 32.12 402.62",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.84 391.17 26.84 402.62 162.46 402.62 162.46 391.17 92.01 391.17 26.84 391.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.65 443.57 158.06 443.57 158.06 402.62 162.46 402.62 162.46 391.17 92.01 391.17 92.01 401.56 94.65 443.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.74,
    y: 409.22,
    width: 25.54,
    height: 6.16,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.45,
    y: 423.09,
    width: 32.79,
    height: 13.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.5 350.27 51.5 391.22 111.38 391.22 177.43 391.22 177.43 350.27 51.5 350.27",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.21 338.82 46.21 350.27 181.84 350.27 181.84 338.82 111.38 338.82 46.21 338.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.02 391.22 177.43 391.22 177.43 350.27 181.84 350.27 181.84 338.82 111.38 338.82 111.38 349.21 114.02 391.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.11,
    y: 356.87,
    width: 25.54,
    height: 6.16,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.82,
    y: 370.75,
    width: 32.79,
    height: 13.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.7,
    y: 38.35,
    width: 93.24,
    height: 135.15,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 38.35,
    width: 93.24,
    height: 135.15,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.61,
    y: 52.99,
    width: 70.07,
    height: 105.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,158.86s0-.18,0-.52,0-.85,0-1.5c0-1.33,0-3.28,0-5.81,0-5.07,0-12.47-.06-21.81,0-18.66-.07-45.1-.11-76.23l.23.23-70.06,0h0l.25-.25c0,39.94,0,76.76,0,105.87l-.2-.2,51,.1,14.09.05,3.7,0c.84,0,1.28,0,1.28,0l-1.24,0-3.66,0-14,0-51.13.11h-.2v-.2c0-29.11,0-65.93,0-105.87v-.26h.26l70.06,0h.23V53c0,31.19-.08,57.68-.11,76.39,0,9.31,0,16.69-.07,21.75,0,2.51,0,4.44,0,5.76,0,.64,0,1.14,0,1.48S112.68,158.86,112.68,158.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.53,38.35a16.55,16.55,0,0,1-1.67,2.42c-1.08,1.44-2.62,3.41-4.37,5.54s-3.4,4-4.61,5.36a17,17,0,0,1-2,2.1,16.88,16.88,0,0,1,1.78-2.33L118.1,46l4.48-5.45A17.49,17.49,0,0,1,124.53,38.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,158.52a86.46,86.46,0,0,0,12.22,15.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,173.8a13,13,0,0,1-2.13-1.94A68.56,68.56,0,0,1,114.46,161a13.47,13.47,0,0,1-1.42-2.5,19.79,19.79,0,0,1,1.72,2.3c1,1.44,2.47,3.42,4.15,5.53s3.3,4,4.48,5.27A20.33,20.33,0,0,1,125.26,173.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,173.39l12.21-15.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.22,158.32a91.61,91.61,0,0,1-5.9,7.69A92.06,92.06,0,0,1,31,173.39a93.18,93.18,0,0,1,5.91-7.69A93.3,93.3,0,0,1,43.22,158.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,38.35A83.08,83.08,0,0,1,37,45.44a82.28,82.28,0,0,1,5.53,7.4,85.34,85.34,0,0,1-5.93-7.09A87.22,87.22,0,0,1,31,38.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.39,
    y: 74.48,
    width: 23.46,
    height: 66.62,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632,429.25c-2.2-1.89-7.12-7.88-3.33-14.85,1.39-2.56,4.35-3.82,7-4.95s5.48-2.1,7.7-4c4.17-3.55,5.32-9.45,8.09-14.18,3.18-5.44,9.11-9.51,15.38-9.23,7.18.33,13.17,6.19,15.88,12.88s2.81,14.11,2.87,21.33c0,4-.15,8.49-3.08,11.19-2.7,2.49-6.77,2.52-10.43,2.4l-39.24-1.2",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.05,321.36H603.86l18.59,110.83a12.37,12.37,0,0,0,8.81,9.87l.36.1c.31.07.6.18.92.23a12.05,12.05,0,0,0,2.1.24v.11l.51-.08h46a13.23,13.23,0,0,0,2.53-.25,12.42,12.42,0,0,0,10.43-10.83l9-76.37.4-3h-.05L707,321.93Zm-19.47,70.69H677l1.07-32.16h12.27Zm3.78-32.16H701.5l-3.78,32.16h-9.11Zm-30.25,67.82-.65-27.94h15.25l-.93,27.94Zm-16.49-27.94h14.82l.64,27.94H646.79Zm1.14,27.94H633.34c-1.18-7.54-2.72-17.35-4.38-27.94h14.63ZM644,392.05l-2.5-32.16h17l.74,32.16Zm16.26,0-.74-32.16H677L676,392.05Zm-.91-39.88-.69-29.78h19.6l-1,29.78Zm-1,0H640.92l-2.31-29.78h19Zm-18.45,0H621.46c-.65-4.11-1.27-8-1.83-11.51-1.92-12-2.64-16.57-3-18.27h21Zm.6,7.72,2.5,32.16H627.75c-.51-3.26-1-6.56-1.55-9.86-1.2-7.6-2.39-15.19-3.52-22.3Zm-13.78,32.16h-10l-5.4-32.16h10.29C623.22,369.83,625,380.89,626.71,392.05Zm1.22,7.72c1.51,9.67,3,19.2,4.37,27.94h-9.56l-4.69-27.94Zm47.88,27.94.93-27.94h10.18l-2.38,27.94Zm2.51-75.54,1-29.78h14.22L691,352.17Zm-62.71-29.78c.41,2.15,2.29,13.87,4.81,29.78H610.07l-5-29.78Zm77.93,105.32h-8L688,399.77h8.87Zm8.86-75.54H692l2.54-29.78H705.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "709.35 45.59 709.35 136.34 579.01 136.34 574.31 46.23 709.35 45.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.52,
    y: 26.02,
    width: 89.92,
    height: 130.34,
    transform: "translate(548.29 730.67) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.27,136.77H573.69V45.61H705.27Zm-130.34-1.24H704V46.85H574.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.43,
    y: 57.4,
    width: 102.1,
    height: 67.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.53,57.4l-.5,0-1.45,0-5.61,0-21,.08-73.5.15.29-.3c0,20.65,0,43.53,0,67.57h0l-.32-.32,102.1.06-.25.26c.05-20.57.1-37.43.13-49.17,0-5.87.05-10.45.07-13.6q0-2.33,0-3.57c0-.81,0-1.24,0-1.24s0,.39,0,1.19,0,2,0,3.52c0,3.13,0,7.7.06,13.54,0,11.78.08,28.7.14,49.33v.26h-.26l-102.1.06h-.32V125h0c0-24,0-46.92,0-67.57v-.29h.3l73.69.14,21,.08,5.55,0h1.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.31,46a10.81,10.81,0,0,1,2.24,1.45c1.34,1,3.15,2.33,5.11,3.9s3.69,3.05,4.9,4.16a10.46,10.46,0,0,1,1.87,1.91c-.12.14-3.26-2.45-7.17-5.57S574.2,46.12,574.31,46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.65,46.23c.11.14-3,2.75-6.86,5.84s-7.15,5.47-7.26,5.33,3-2.75,6.86-5.84S704.54,46.09,704.65,46.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.55,136.16,690,124.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690,124.39c.12-.14,3.46,2.38,7.47,5.63s7.18,6,7.07,6.14-3.46-2.38-7.47-5.64S689.9,124.52,690,124.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.31,136.15c-.11-.14,2.93-2.73,6.79-5.78s7.07-5.41,7.18-5.27-2.92,2.73-6.78,5.78S574.42,136.29,574.31,136.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.97,
    y: 57.65,
    width: 22.63,
    height: 64.25,
    transform: "translate(551.51 731.05) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.05,443.57c0,.14-150.32.26-335.71.26s-335.74-.12-335.74-.26,150.29-.26,335.74-.26S707.05,443.42,707.05,443.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.18,94H626.94a6.74,6.74,0,0,1,6.74,6.74V425.44A14.57,14.57,0,0,1,619.12,440H125a14.57,14.57,0,0,1-14.57-14.57V101.74A7.75,7.75,0,0,1,118.18,94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.55,414.42H655.45a0,0,0,0,1,0,0V431a13.72,13.72,0,0,1-13.72,13.72H102.27A13.72,13.72,0,0,1,88.55,431V414.42a0,0,0,0,1,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 107.73,
    width: 493.7,
    height: 292.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.47 414.42 327.51 425.61 426.5 425.61 433.03 414.42 320.47 414.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.51,
    y: 414.31,
    width: 523.26,
    height: 1.67,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Certification--inject-565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.26,94H209.9V74.84c0-13.51,10.95-24.94,24.46-24.94l29.9.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.19,49.87s30.94-2.81,30.94,37.54V401.26h242.8V76a26.67,26.67,0,0,0-26.72-26.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.19,49.87l179.63-.58,43.5-.12,23.13-.07a27,27,0,0,1,21.37,9.57,26.91,26.91,0,0,1,5.55,11,24.38,24.38,0,0,1,.57,3.09c.14,1,.13,2.09.2,3.14q0,3.13,0,6.3,0,12.63,0,25.67,0,26.05,0,53.59c0,73.34,0,154,0,238.6v1.46h-.26l-242.8,0h-.24v-.24c0-108.66.07-200.93.1-266,0-16.28,0-30.86,0-43.57,0-3.18,0-6.24-.18-9.17a55.78,55.78,0,0,0-1.16-8.36,43.41,43.41,0,0,0-2.38-7.33,33.55,33.55,0,0,0-3.48-6,26.51,26.51,0,0,0-8.77-7.51,28.84,28.84,0,0,0-8-2.82,29.37,29.37,0,0,0-5.14-.58c-1.16,0-1.76,0-1.76,0a14.78,14.78,0,0,1,1.76,0,29.64,29.64,0,0,1,5.16.54,28.8,28.8,0,0,1,8,2.8,26.45,26.45,0,0,1,8.83,7.52,33.85,33.85,0,0,1,3.52,6,43.78,43.78,0,0,1,2.41,7.36,56,56,0,0,1,1.18,8.39c.22,2.94.19,6,.19,9.18,0,12.71,0,27.29,0,43.57,0,65.11.05,157.38.09,266l-.24-.23,242.8,0-.26.26v-1.2c0-84.63,0-165.26,0-238.6q0-27.51,0-53.59V82.2c-.06-4.21.31-8.43-.75-12.43A26.54,26.54,0,0,0,500.49,59a26.52,26.52,0,0,0-21-9.43l-23.18,0-43.57.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.06,145.12c0,.14-14.77.26-33,.26s-33-.12-33-.26,14.76-.26,33-.26S368.06,145,368.06,145.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.84,153c0,.15-18.07.26-40.37.26s-40.36-.11-40.36-.26,18.07-.26,40.36-.26S382.84,152.86,382.84,153Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.14,184.05c0,.14-18.66.26-41.68.26s-41.68-.12-41.68-.26,18.66-.26,41.68-.26S388.14,183.9,388.14,184.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,214.31c0,.14-31.2.26-69.68.26s-69.68-.12-69.68-.26,31.19-.26,69.68-.26S442.59,214.16,442.59,214.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,223.33c0,.15-31.2.26-69.68.26s-69.68-.11-69.68-.26,31.19-.26,69.68-.26S442.59,223.19,442.59,223.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,232.36c0,.15-31.2.26-69.68.26s-69.68-.11-69.68-.26,31.19-.26,69.68-.26S442.59,232.22,442.59,232.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,241.39c0,.14-31.2.26-69.68.26s-69.68-.12-69.68-.26,31.19-.26,69.68-.26S442.59,241.25,442.59,241.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.59,250.42c0,.14-31.2.26-69.68.26s-69.68-.12-69.68-.26,31.19-.26,69.68-.26S442.59,250.27,442.59,250.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.08,259.45c0,.14-11.84.26-26.43.26s-26.42-.12-26.42-.26,11.83-.26,26.42-.26S356.08,259.3,356.08,259.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.21,98.48a5.61,5.61,0,0,1,6-5.65,5.74,5.74,0,0,1,4.67,2l-1.95,1.77a3.22,3.22,0,0,0-2.56-1.27,3.1,3.1,0,0,0,0,6.2,3.22,3.22,0,0,0,2.56-1.27l1.95,1.76a5.74,5.74,0,0,1-4.67,2.05A5.61,5.61,0,0,1,325.21,98.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.92,101.53v2.37h-8.71V93.05h8.51v2.37h-5.48v1.83h4.83v2.3h-4.83v2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.37,101H350.7v2.88h-3.07V93.05h5c3,0,4.82,1.53,4.82,4a3.6,3.6,0,0,1-2.13,3.42l2.35,3.41h-3.29Zm0-5.55h-1.7v3.18h1.7c1.27,0,1.91-.59,1.91-1.58S353.67,95.47,352.4,95.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.25,95.48h-3.33V93.05h9.72v2.43h-3.32v8.42h-3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.79,93.05h3.07V103.9h-3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.12,95.42v2.39h4.79v2.37h-4.79v3.72h-3.07V93.05h8.51v2.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,93.05h3.07V103.9H384Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7,98.48a5.62,5.62,0,0,1,6-5.65,5.72,5.72,0,0,1,4.66,2l-1.95,1.77a3.21,3.21,0,0,0-2.56-1.27,3.1,3.1,0,0,0,0,6.2,3.21,3.21,0,0,0,2.56-1.27l1.95,1.76a5.72,5.72,0,0,1-4.66,2.05C391.23,104.12,388.7,101.78,388.7,98.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.78,101.79H403.2l-.86,2.11h-3.13L404,93.05h3l4.8,10.85h-3.19Zm-.89-2.26-1.4-3.47-1.4,3.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.47,95.48h-3.33V93.05h9.72v2.43h-3.32v8.42h-3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,93.05h3.07V103.9H422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7,98.48c0-3.26,2.56-5.65,6-5.65s6,2.39,6,5.65-2.56,5.64-6,5.64S426.7,101.73,426.7,98.48Zm9,0a2.93,2.93,0,1,0-2.93,3.1A2.9,2.9,0,0,0,435.66,98.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.7,93.05V103.9h-2.53l-4.79-5.78v5.78h-3V93.05h2.52l4.79,5.78V93.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,297.56c0,.14-13.84.26-30.9.26s-30.91-.12-30.91-.26,13.84-.26,30.91-.26S463,297.42,463,297.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,306.28c0,.14-13.84.26-30.9.26s-30.91-.12-30.91-.26S415,306,432.11,306,463,306.14,463,306.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.9,344.17a2.19,2.19,0,0,1,0-.44c0-.31-.05-.73-.09-1.27q0-.42-.06-.93c0-.35-.11-.72-.17-1.12a19.73,19.73,0,0,0-.57-2.76,25.19,25.19,0,0,0-3-7.09,26.58,26.58,0,0,0-31.93-11.33,27.75,27.75,0,0,0-3.46,1.52,29,29,0,0,0-3.26,2.09,30.19,30.19,0,0,0-3,2.56,30.88,30.88,0,0,0-2.6,3.08,25.52,25.52,0,0,0-3.79,7.31,26.28,26.28,0,0,0,0,16.75,25.52,25.52,0,0,0,3.79,7.31,30.88,30.88,0,0,0,2.6,3.08,30.19,30.19,0,0,0,3,2.56,24.92,24.92,0,0,0,6.72,3.62A26.75,26.75,0,0,0,437,370.28a26.73,26.73,0,0,0,18-12.51,25.19,25.19,0,0,0,3-7.09,19.44,19.44,0,0,0,.57-2.76c.06-.4.13-.77.17-1.11s0-.66.06-.94c0-.54.07-1,.09-1.27a2,2,0,0,1,0-.43,2.3,2.3,0,0,1,0,.43l0,1.28c0,.28,0,.6,0,.94s-.09.72-.15,1.13a18.17,18.17,0,0,1-.52,2.78,25.31,25.31,0,0,1-2.92,7.19,26.88,26.88,0,0,1-32.34,11.64,28.15,28.15,0,0,1-3.53-1.54,27.09,27.09,0,0,1-3.32-2.13,30.07,30.07,0,0,1-3.08-2.6,31,31,0,0,1-2.65-3.14,26,26,0,0,1-3.87-7.45,26.72,26.72,0,0,1,0-17.07,26.13,26.13,0,0,1,3.87-7.45,29.68,29.68,0,0,1,2.66-3.13,30.26,30.26,0,0,1,3.07-2.61,26.92,26.92,0,0,1,39.19,8,25.43,25.43,0,0,1,2.92,7.19,18.06,18.06,0,0,1,.52,2.79c.06.41.12.78.15,1.12s0,.66,0,.95l0,1.27A2.44,2.44,0,0,1,458.9,344.17Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.1,
    cy: 344.17,
    r: 17.22,
    transform: "translate(-2.73 684.88) rotate(-76.62)",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.4,329.34l-.72.4-2.15,1.14-8.27,4.31L446.19,342a13.16,13.16,0,0,1-4.25,1.36,5.78,5.78,0,0,1-4.52-1.38,4.23,4.23,0,0,1-1.33-2.15,2.73,2.73,0,0,1,.57-2.53,3.59,3.59,0,0,1,2.41-1.16,2.25,2.25,0,0,1,2.36,1.32v.07a11.88,11.88,0,0,1-2.89,7.87,11.19,11.19,0,0,1-8,4,12.13,12.13,0,0,1-8.89-3.21,8.08,8.08,0,0,1-2.56-4.31,4.12,4.12,0,0,1,.34-2.6,3.71,3.71,0,0,1,1.94-1.82,2.79,2.79,0,0,1,2.67.37,4.51,4.51,0,0,1,1.51,2.24,8,8,0,0,1,.41,2.65,7.5,7.5,0,0,1,0,1.34,8.62,8.62,0,0,1-.17,1.34,15.55,15.55,0,0,1-5.58,9.21,13.63,13.63,0,0,1-10.6,3,15.29,15.29,0,0,1-9.7-5.9,14.53,14.53,0,0,1-2.78-6,11.17,11.17,0,0,1,.49-6.52,5.53,5.53,0,0,1,2.14-2.52,4.59,4.59,0,0,1,3.24-.61,3.82,3.82,0,0,1,2.56,2,11.75,11.75,0,0,1,1.06,3,21.4,21.4,0,0,1-.74,12.17,17.39,17.39,0,0,1-7.35,9,17,17,0,0,1-10.83,2.37,14.13,14.13,0,0,1-5.13-1.66,13.9,13.9,0,0,1-4-3.39,14.42,14.42,0,0,1-3.31-9.18,12.14,12.14,0,0,1,1-4.58,5.56,5.56,0,0,1,3.1-3.19,4.09,4.09,0,0,1,2.22-.06,4.74,4.74,0,0,1,1.83,1.11,8.75,8.75,0,0,1,2.11,3.46,11.29,11.29,0,0,1,.67,3.75c0,.62,0,1.22,0,1.82s-.05,1.18-.11,1.75a30.05,30.05,0,0,1-3.37,11.23,29.2,29.2,0,0,1-4.28,6.07c-.57.63-1.05,1.07-1.37,1.37s-.49.44-.49.44.15-.17.46-.48.76-.76,1.32-1.4a30.68,30.68,0,0,0,4.18-6.09,30.22,30.22,0,0,0,3.26-11.16c.06-.57.09-1.15.1-1.74s0-1.19,0-1.8a11.14,11.14,0,0,0-.67-3.65,8.42,8.42,0,0,0-2-3.31,4.31,4.31,0,0,0-1.69-1,3.68,3.68,0,0,0-2,.06,5.21,5.21,0,0,0-2.87,3,11.87,11.87,0,0,0-.91,4.42,14.11,14.11,0,0,0,3.24,8.91,13.15,13.15,0,0,0,8.83,4.86,16.58,16.58,0,0,0,10.53-2.32,16.89,16.89,0,0,0,7.13-8.79,20.84,20.84,0,0,0,.71-11.88,11.09,11.09,0,0,0-1-2.87,3.33,3.33,0,0,0-2.23-1.77,4,4,0,0,0-2.86.56,4.82,4.82,0,0,0-1.93,2.29,10.54,10.54,0,0,0-.46,6.2,14,14,0,0,0,2.69,5.79,14.82,14.82,0,0,0,9.36,5.7,13.16,13.16,0,0,0,10.2-2.93,15,15,0,0,0,5.4-8.9,12,12,0,0,0,.2-2.58,7.47,7.47,0,0,0-.38-2.5,4.15,4.15,0,0,0-1.33-2,2.31,2.31,0,0,0-2.21-.3,3.27,3.27,0,0,0-1.68,1.58,3.64,3.64,0,0,0-.3,2.3,7.59,7.59,0,0,0,2.42,4,11.64,11.64,0,0,0,8.53,3.11,10.71,10.71,0,0,0,7.67-3.84,11.49,11.49,0,0,0,2.82-7.59v.07a1.83,1.83,0,0,0-2-1.07,3.17,3.17,0,0,0-2.14,1,2.37,2.37,0,0,0-.5,2.2,3.85,3.85,0,0,0,1.22,2,5.35,5.35,0,0,0,4.23,1.3,12.66,12.66,0,0,0,4.15-1.3l13.1-6.67,8.33-4.21,2.17-1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,82.65c0,.15-21.15.27-47.24.27s-47.25-.12-47.25-.27,21.15-.26,47.25-.26S380.82,82.51,380.82,82.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.57,82.65a20.06,20.06,0,0,1-6.56,0,20.82,20.82,0,0,1,6.56,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.63,82.65c0,.15-19.3.27-43.09.27s-43.09-.12-43.09-.27,19.28-.26,43.09-.26S490.63,82.51,490.63,82.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,108.94c0,.15-21.15.26-47.24.26s-47.25-.11-47.25-.26,21.15-.26,47.25-.26S380.82,108.8,380.82,108.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.57,108.94a20.82,20.82,0,0,1-6.56,0,20.82,20.82,0,0,1,6.56,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.63,108.94c0,.15-19.3.26-43.09.26s-43.09-.11-43.09-.26,19.28-.26,43.09-.26S490.63,108.8,490.63,108.94Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Label--inject-565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.51,213l-24.79,57.61a1.45,1.45,0,0,0,1.92,1.91l19.11-8.44a1.46,1.46,0,0,1,2,.88l6.45,19.35a1.45,1.45,0,0,0,2.74,0l23.31-62.14Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.82,222.63l11.87,61.58a1.46,1.46,0,0,0,2.67.5L525.42,267a1.46,1.46,0,0,1,2.12-.39L543.75,279a1.46,1.46,0,0,0,2.3-1.5L530.39,213Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467.51,213l-24.79,57.61a1.45,1.45,0,0,0,1.92,1.91l19.11-8.44a1.46,1.46,0,0,1,2,.88l6.45,19.35a1.45,1.45,0,0,0,2.74,0l23.31-62.14Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M499.82,222.63l11.87,61.58a1.46,1.46,0,0,0,2.67.5L525.42,267a1.46,1.46,0,0,1,2.12-.39L543.75,279a1.46,1.46,0,0,0,2.3-1.5L530.39,213Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "501.02 112.06 509.16 106.08 515.56 113.89 524.93 110.13 529.18 119.29 539.2 117.97 541.03 127.9 551.06 129.11 550.37 139.19 559.78 142.85 556.61 152.44 564.81 158.34 559.36 166.84 565.84 174.58 558.43 181.46 562.79 190.57 553.91 195.39 555.86 205.3 546.06 207.76 545.48 217.84 535.38 217.79 532.31 227.41 522.54 224.85 517.17 233.4 508.35 228.49 501.02 235.44 493.7 228.49 484.88 233.4 479.51 224.85 469.74 227.41 466.67 217.79 456.57 217.84 455.99 207.76 446.19 205.3 448.14 195.39 439.26 190.57 443.61 181.46 436.21 174.58 442.69 166.84 437.24 158.34 445.44 152.44 442.26 142.85 451.68 139.19 450.99 129.11 461.02 127.9 462.85 117.97 472.87 119.29 477.12 110.13 486.49 113.89 492.88 106.08 501.02 112.06",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 501.02,
    cy: 170.76,
    r: 45.75,
    transform: "translate(26 404.29) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,159.92l12.27,1.8a2.46,2.46,0,0,1,1.36,4.2l-8.89,8.65a2.45,2.45,0,0,0-.71,2.18L517.12,189a2.46,2.46,0,0,1-3.57,2.59l-11-5.79a2.44,2.44,0,0,0-2.29,0l-11,5.76a2.46,2.46,0,0,1-3.56-2.6l2.11-12.22a2.47,2.47,0,0,0-.7-2.18l-8.88-8.67a2.46,2.46,0,0,1,1.37-4.2l12.28-1.77a2.43,2.43,0,0,0,1.85-1.34l5.51-11.12a2.46,2.46,0,0,1,4.41,0l5.47,11.14A2.45,2.45,0,0,0,511,159.92Z",
    style: {
      fill: "#C53F3F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.76,207.1s-11.92,48.83-65.29,37.64C613.47,244.74,628.94,195.29,678.76,207.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653,281.05s-24.5,36.53-65,11.27C588,292.32,615.6,256.35,653,281.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.94,336.78s-35.74,30.39-70-7.28C544,329.5,582.73,300.58,613.94,336.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.09,218.63s39.64,19.05,20.4,62.71C596.49,281.34,557,259.14,576.09,218.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.49,271.27s19.77,26.69-9.7,49.62C557.79,320.89,539.28,292.1,567.49,271.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.18,150s4.55,39.58-38.2,45.92C621,195.92,618.89,154.9,659.18,150Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.87,110s34.57,14.44,19.56,55C617.43,164.92,582.78,147.62,597.87,110Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,167.78s45.78,5.22,41.75,55.05C618.75,222.83,572,214.45,577,167.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.85,341.71s.19-.07.58-.18l1.71-.45c1.51-.4,3.74-.93,6.56-1.85a126.34,126.34,0,0,0,23-9.7,140.13,140.13,0,0,0,29.86-21.89,157.16,157.16,0,0,0,14.75-16.2l3.44-4.62,1.73-2.33c.56-.8,1.07-1.63,1.62-2.45l3.23-5,3-5.22c.49-.88,1-1.75,1.48-2.62s.89-1.8,1.33-2.69c.88-1.79,1.77-3.55,2.62-5.33s1.52-3.6,2.28-5.38c.37-.89.77-1.77,1.11-2.66l1-2.7,1.91-5.32c.53-1.79,1-3.57,1.57-5.32.26-.88.52-1.75.77-2.62s.43-1.75.65-2.62l1.21-5.16a154.52,154.52,0,0,0,3.41-36.9,159.51,159.51,0,0,0-2.78-24.87c-.63-2.9-1.18-5.13-1.51-6.65-.17-.75-.3-1.32-.39-1.73s-.11-.59-.11-.59.06.19.16.58l.44,1.72c.37,1.51,1,3.74,1.61,6.63a150.51,150.51,0,0,1-.36,61.91q-.6,2.55-1.21,5.18c-.21.87-.38,1.76-.64,2.63s-.51,1.75-.77,2.63l-1.57,5.33-1.91,5.34c-.32.9-.64,1.8-1,2.71s-.74,1.78-1.12,2.68l-2.28,5.4c-.85,1.78-1.75,3.55-2.62,5.34l-1.34,2.7c-.49.88-1,1.75-1.49,2.63l-3,5.24-3.25,5c-.55.82-1.06,1.65-1.63,2.45l-1.74,2.35-3.45,4.63A155.86,155.86,0,0,1,573.94,308a139.31,139.31,0,0,1-30,21.87,124,124,0,0,1-23.16,9.57c-2.83.89-5.08,1.39-6.6,1.75l-1.72.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.2,292.79a4,4,0,0,1,0,1.12c-.06.71-.17,1.75-.32,3-.31,2.55-.84,6.06-1.59,9.91s-1.59,7.31-2.26,9.78c-.34,1.24-.62,2.24-.84,2.93a4.55,4.55,0,0,1-.39,1.05,5.37,5.37,0,0,1,.19-1.1c.19-.81.42-1.8.68-3,.58-2.49,1.36-5.95,2.11-9.79s1.33-7.33,1.73-9.86c.19-1.18.36-2.18.49-3A5.23,5.23,0,0,1,563.2,292.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.94,332.43a4.27,4.27,0,0,1-1.12-.1l-3-.45c-2.56-.38-6.11-.88-10-1.34s-7.49-.79-10.07-1l-3.06-.27a5.32,5.32,0,0,1-1.12-.16,4.39,4.39,0,0,1,1.13,0c.73,0,1.78,0,3.07.1,2.6.13,6.17.4,10.11.86s7.48,1,10,1.5c1.28.24,2.3.45,3,.61A4.36,4.36,0,0,1,572.94,332.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.12,284a6.84,6.84,0,0,1-1.32.32l-3.62.71c-3.06.61-7.27,1.49-11.89,2.6s-8.77,2.27-11.77,3.13l-3.55,1a6.92,6.92,0,0,1-1.31.32,5.68,5.68,0,0,1,1.25-.52c.82-.3,2-.7,3.51-1.18,3-.95,7.11-2.16,11.74-3.28s8.87-1.95,12-2.46c1.54-.26,2.79-.44,3.66-.55A6.44,6.44,0,0,1,621.12,284Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.13,246.55a7.36,7.36,0,0,1,.81,1.21c.51.8,1.18,2,1.95,3.47a67.91,67.91,0,0,1,7.22,25.12c.14,1.67.2,3,.2,4a7.59,7.59,0,0,1,0,1.46,7.61,7.61,0,0,1-.16-1.45c-.05-.93-.17-2.28-.36-3.95a76.36,76.36,0,0,0-7.18-25c-.73-1.51-1.34-2.71-1.79-3.54A7.73,7.73,0,0,1,586.13,246.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.23,223.78a6.46,6.46,0,0,1-1.05.74l-2.94,1.91c-2.46,1.64-5.8,4-9.3,6.82s-6.5,5.62-8.61,7.69l-2.48,2.48a6.25,6.25,0,0,1-.94.87,6.46,6.46,0,0,1,.79-1c.54-.63,1.35-1.52,2.37-2.59a92.77,92.77,0,0,1,8.54-7.84,94.48,94.48,0,0,1,9.43-6.73c1.27-.78,2.3-1.38,3-1.78A5.43,5.43,0,0,1,639.23,223.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.24,187.63a2.13,2.13,0,0,1,.38.29l1,.9c.87.79,2.11,2,3.6,3.43,3,2.94,7,7.13,11.16,12s7.66,9.5,10.09,12.92c1.21,1.71,2.17,3.11,2.81,4.09l.73,1.14c.16.27.24.41.22.42a1.71,1.71,0,0,1-.31-.36l-.81-1.08-2.94-4c-2.5-3.36-6-7.94-10.19-12.8s-8.1-9.09-11-12.09L590.48,189l-.94-1C589.33,187.77,589.23,187.65,589.24,187.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.38,162.86a9.39,9.39,0,0,1-1,1.24l-2.78,3.28c-2.33,2.78-5.46,6.69-8.68,11.19s-5.9,8.73-7.78,11.84L622,194.09a8.86,8.86,0,0,1-.85,1.33,10.28,10.28,0,0,1,.67-1.43c.46-.9,1.17-2.19,2.07-3.77,1.8-3.16,4.45-7.43,7.68-11.95s6.42-8.41,8.82-11.13c1.2-1.37,2.2-2.45,2.91-3.18A9.16,9.16,0,0,1,644.38,162.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603,125.28a12,12,0,0,1,.72,1.46c.43.94,1,2.32,1.76,4,1.45,3.42,3.37,8.2,5.34,13.53s3.62,10.2,4.75,13.75c.57,1.77,1,3.21,1.3,4.21a10.26,10.26,0,0,1,.4,1.57,8.79,8.79,0,0,1-.6-1.51l-1.45-4.16c-1.21-3.51-2.92-8.36-4.89-13.68s-3.83-10.11-5.19-13.57c-.66-1.67-1.2-3-1.61-4.11A7.86,7.86,0,0,1,603,125.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,196.23s11.27,46.14,61.7,35.57C141.67,231.8,127.05,185.07,80,196.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.34,266.11s23.15,34.52,61.4,10.65C165.74,276.76,139.66,242.77,104.34,266.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.22,318.77S175,347.5,207.35,311.9C207.35,311.9,170.72,284.56,141.22,318.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,207.13s-37.46,18-19.28,59.25C157.71,266.38,195.07,245.41,177,207.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.12,256.87s-18.68,25.22,9.16,46.89C194.28,303.76,211.78,276.56,185.12,256.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.48,142.27s-4.3,37.4,36.1,43.39C134.58,185.66,136.54,146.9,98.48,142.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.42,104.42s-32.68,13.65-18.49,52C137.93,156.37,170.67,140,156.42,104.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14,159.07s-43.27,4.94-39.46,52C136.68,211.09,180.87,203.18,176.14,159.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.19,326.63l-.59-.11-1.71-.38c-1.5-.35-3.72-.82-6.53-1.65a142.09,142.09,0,0,1-23.17-8.69,140.59,140.59,0,0,1-15-8.24A138.41,138.41,0,0,1,184.32,296a140.72,140.72,0,0,1-15.51-15.18l-3.64-4.39c-1.18-1.51-2.3-3.08-3.47-4.63-.58-.78-1.16-1.57-1.75-2.35L158.34,267c-1.06-1.66-2.19-3.3-3.22-5-2-3.48-4-6.86-5.65-10.4-1.8-3.45-3.22-7-4.7-10.48a143.38,143.38,0,0,1-7.54-81.79c.6-2.86,1.21-5.05,1.56-6.55.19-.73.33-1.3.43-1.7s.17-.57.17-.57,0,.2-.12.59-.21,1-.38,1.7c-.32,1.51-.9,3.71-1.47,6.57a152.49,152.49,0,0,0-2.59,24.56,149.1,149.1,0,0,0,10.42,57c1.47,3.45,2.89,7,4.69,10.44,1.63,3.52,3.67,6.89,5.62,10.36,1,1.7,2.15,3.33,3.21,5l1.61,2.46,1.74,2.34c1.16,1.55,2.28,3.12,3.45,4.62l3.63,4.37a143.3,143.3,0,0,0,31.22,26.72,148.13,148.13,0,0,0,38,17.09c2.79.86,5,1.36,6.5,1.74l1.69.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.17,277.2a5.18,5.18,0,0,1,.23,1c.13.78.28,1.72.46,2.83.38,2.39.94,5.69,1.64,9.32s1.44,6.89,2,9.25c.25,1.09.46,2,.64,2.8a4,4,0,0,1,.17,1,4.59,4.59,0,0,1-.37-1c-.2-.64-.48-1.59-.8-2.76-.64-2.34-1.42-5.6-2.14-9.24s-1.2-7-1.49-9.37c-.15-1.2-.25-2.18-.3-2.86A4.11,4.11,0,0,1,189.17,277.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,314.66a5,5,0,0,1,1-.29c.66-.15,1.64-.35,2.84-.58,2.41-.45,5.76-1,9.48-1.42s7.1-.69,9.55-.8c1.23-.06,2.22-.1,2.9-.1a4.09,4.09,0,0,1,1.07,0,4.37,4.37,0,0,1-1.05.15l-2.89.26c-2.44.21-5.81.53-9.52,1s-7,.91-9.48,1.27l-2.87.41A4,4,0,0,1,180,314.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44,268.88a5.34,5.34,0,0,1,1.28.11c.82.1,2,.27,3.45.51,2.92.48,6.92,1.26,11.3,2.32s8.29,2.2,11.1,3.11c1.4.45,2.53.84,3.31,1.12a6.16,6.16,0,0,1,1.18.49,5.41,5.41,0,0,1-1.25-.3l-3.35-1c-2.83-.81-6.75-1.89-11.12-2.95s-8.34-1.89-11.23-2.47l-3.42-.67A6.91,6.91,0,0,1,134.44,268.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,233.51a7.53,7.53,0,0,1-.6,1.24c-.42.78-1,1.92-1.69,3.35a73.18,73.18,0,0,0-4.4,11.51,74.66,74.66,0,0,0-2.39,12.09c-.17,1.57-.29,2.85-.34,3.73a6.8,6.8,0,0,1-.16,1.37,7.86,7.86,0,0,1-.05-1.38c0-.89.05-2.17.18-3.75a64.77,64.77,0,0,1,2.26-12.21,63.69,63.69,0,0,1,4.57-11.53c.73-1.41,1.36-2.53,1.84-3.28A6.17,6.17,0,0,1,167.51,233.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.33,212a6,6,0,0,1,1.09.53c.69.37,1.67.94,2.87,1.68a89.38,89.38,0,0,1,8.92,6.35,88.46,88.46,0,0,1,8.06,7.41c1,1,1.73,1.85,2.24,2.45a6.24,6.24,0,0,1,.75,1,5.26,5.26,0,0,1-.9-.83L138,228.22c-2-2-4.82-4.58-8.13-7.27s-6.47-4.9-8.79-6.44l-2.77-1.82A5.09,5.09,0,0,1,117.33,212Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.57,177.83a11.66,11.66,0,0,1-1.17,1.27l-3.29,3.35c-2.75,2.83-6.49,6.83-10.41,11.42s-7.26,8.92-9.63,12.1l-2.78,3.77a11.35,11.35,0,0,1-1.06,1.35,11.19,11.19,0,0,1,.89-1.47c.6-.93,1.51-2.26,2.65-3.87,2.3-3.24,5.61-7.61,9.54-12.22S157,185,159.85,182.19c1.42-1.39,2.58-2.5,3.41-3.24A11.93,11.93,0,0,1,164.57,177.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.46,154.42a8.6,8.6,0,0,1,1.08,1c.67.69,1.61,1.71,2.74,3A131.43,131.43,0,0,1,124.62,169c3,4.27,5.56,8.31,7.26,11.29.85,1.49,1.51,2.71,2,3.57a7.87,7.87,0,0,1,.63,1.36,9.39,9.39,0,0,1-.81-1.26l-2.09-3.48c-1.78-2.93-4.32-6.92-7.36-11.18s-6-7.95-8.2-10.58c-1-1.26-1.93-2.3-2.61-3.1A7.34,7.34,0,0,1,112.46,154.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.58,118.91a9.22,9.22,0,0,1-.5,1.45c-.39,1-.9,2.31-1.52,3.88-1.28,3.27-3,7.8-4.9,12.83S141.18,146.68,140,150c-.56,1.59-1,2.91-1.37,3.93a7.83,7.83,0,0,1-.57,1.42,9.14,9.14,0,0,1,.37-1.48c.27-1,.69-2.31,1.22-4,1.07-3.35,2.62-8,4.49-13s3.68-9.54,5.05-12.78c.69-1.62,1.26-2.92,1.67-3.82A8.19,8.19,0,0,1,151.58,118.91Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.14,166c7.29.95,8.37,8.42,11.07,14.69s7.87,11.85,11.85,17.46c2.1,3,5,5.63,5.72,9.15.79,3.68-.89,7.49-1.68,11.24s-.23,8.34,3.37,10a4,4,0,0,1-3.3,1.39c0,1.73-1.67,3.22-3.49,3.72a13.48,13.48,0,0,1-5.55-.06c.49,1.15-.55,2.54-1.84,3a7.58,7.58,0,0,1-4,0,9.89,9.89,0,0,0-4-.29c-3,.65-4.75,4-7.75,4.42-4.12.6-7.08-4.67-11.15-3.75-1.91.43-3.18,2.1-4.75,3.24s-4.22.85-5-.79c-2.18,2.75-5.55,5.42-9.1,6.15a3.3,3.3,0,0,0-.69-3.6,14,14,0,0,1-6.77,3,7,7,0,0,0,2.26-5.42,7,7,0,0,1-6,1.29c3.66-2.09,4-6.95,2.72-10.6s-3.78-6.92-4.26-10.77c-.53-4.19,4.39-9.49,3.43-13.6-1.48-6.34-1.37-10.2-1.11-16.12.17-3.87,1.88-7.31,3.58-10.92a22.25,22.25,0,0,1,9.7-10.5c3.87-2.18,9.45-4.18,13.88-4.28,7.9-.17,11.11-.42,17.36,3.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8,217.62a97.69,97.69,0,0,1-6.43-15.7,34.3,34.3,0,0,1-.9-16.79c.19-.83,2-6.52,2.86-6.55.61,0-.28,5.17.1,5.66,3.59,4.62,5.2,10.55,5.51,16.39a76.83,76.83,0,0,1-1.14,17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,265.52c-8.73,1-29.73-8.18-30.9-16.88l-7.08-52.36c-2.34-14,3.85-27,17.92-29l1.31-.11a25.38,25.38,0,0,1,27.09,21.26c2,12.15,4,25.59,4.43,32.16.92,13.59-12.49,16.79-12.49,16.79s.34,3.14.83,7.11c1.11,8.92-.31,18.7-1.11,21Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.62,237.38a32.93,32.93,0,0,1-18.11-3.81s5.08,9.87,18.53,7.56Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.62,200.25a1.94,1.94,0,0,1-1.71,2.1,1.85,1.85,0,0,1-2.14-1.59,1.94,1.94,0,0,1,1.71-2.1A1.84,1.84,0,0,1,260.62,200.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.27,194.65c-.22.27-1.77-.7-3.86-.53s-3.53,1.34-3.78,1.1.09-.58.72-1.11a5.3,5.3,0,0,1,3-1.2,5.11,5.11,0,0,1,3.1.73C263.13,194.08,263.38,194.52,263.27,194.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,201.78a2,2,0,0,1-1.71,2.11,1.86,1.86,0,0,1-2.14-1.59,2,2,0,0,1,1.71-2.11A1.87,1.87,0,0,1,241,201.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.85,196.77c-.22.27-1.78-.69-3.86-.52s-3.54,1.34-3.78,1.1.08-.58.71-1.12a5.26,5.26,0,0,1,3-1.19,5.12,5.12,0,0,1,3.11.73C242.71,196.21,243,196.65,242.85,196.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.63,212.21a13.42,13.42,0,0,1,3.34-.88c.53-.1,1-.25,1.08-.62a2.67,2.67,0,0,0-.48-1.55l-1.9-3.93c-2.65-5.6-4.62-10.23-4.39-10.33s2.56,4.35,5.21,9.95l1.84,4a3.09,3.09,0,0,1,.44,2.07,1.34,1.34,0,0,1-.81.85,4,4,0,0,1-.9.2A13.66,13.66,0,0,1,251.63,212.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,189c-.24.55-2.31.15-4.78.3s-4.5.69-4.79.16c-.13-.25.25-.77,1.08-1.27a8.39,8.39,0,0,1,7.29-.35C241.72,188.25,242.15,188.72,242,189Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.39,189.81c-.39.51-2.13.18-4.18.35s-3.74.68-4.18.22c-.2-.22,0-.72.74-1.24a7,7,0,0,1,6.74-.47C262.27,189.09,262.56,189.56,262.39,189.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.28,206.25c-.24-.08-9.55-2-8.51,7.25s10.12,6.31,10.11,6S221.28,206.25,221.28,206.25Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.66,216.35s-.15.13-.41.29a1.66,1.66,0,0,1-1.2.16c-1-.25-2-1.71-2.26-3.38a5.39,5.39,0,0,1,.2-2.36,1.85,1.85,0,0,1,1.07-1.37.83.83,0,0,1,1,.33c.16.25.12.44.17.45s.18-.18.06-.55a1,1,0,0,0-.43-.54,1.23,1.23,0,0,0-.92-.14,2.3,2.3,0,0,0-1.52,1.63,5.59,5.59,0,0,0-.27,2.64c.27,1.86,1.42,3.5,2.8,3.74a1.72,1.72,0,0,0,1.45-.41C219.66,216.58,219.69,216.36,219.66,216.35Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.83,173.82c1.4-1-3.68-5.32-7.56-6.54-5.87-1.85-14.55-2.37-19.51-.29-6,2.5-10.71,6.19-13.13,12.19a36.59,36.59,0,0,0-1.83,19.07,11.07,11.07,0,0,0,2,5.5c1.54,1.89,4.18,2.88,4.41,5.71a4,4,0,0,0,1.3,2.71c1.92,1.59,3.78-.35,4.53-2.16,1.59-3.87,1.29-8.23,1-12.4a27.09,27.09,0,0,0-1.66-8.73c-.64-1.49-1.54-2.86-2.1-4.38a5.6,5.6,0,0,1,.1-4.69A5.22,5.22,0,0,1,226,179a9.73,9.73,0,0,1,9.35-3c5.43,1.21,14.67,2.88,16.78.83,3-3,3.63-4.7,3.63-4.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,214c-.12,0-.14.55.14,1.33a5.2,5.2,0,0,0,2,2.51,8.54,8.54,0,0,0,2.89,1.23c.77.18,1.27.2,1.31.08s-.38-.39-1.08-.73a18.76,18.76,0,0,1-2.56-1.39C246.89,215.84,246.34,213.92,246.05,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.58,207.46c.08.16.15.33.23.52C221.81,208,221.72,207.79,221.58,207.46Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.41,206s1.55-2,3.17,1.42c-1.93-4.54-14.76-37.37,20.42-41.7,0,0-12.71-2.24-20.37,4.08C221.63,169.84,206.05,179.15,218.41,206Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.68,371.78l-81.77,1.11s-22.87-9.57-29.15-9.83-18.76.54-24.53,9.83c-6,9.6-6.79,26.53,11.58,38.83,17.9,12,99.73,23.06,111,22L293.43,406s.22-22.75,0-23.84-3.68-10.83-3.68-10.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.73,410.18l-42.37,15.73,19.31,52.82c4.93-2.16,5.07-33.18,5.07-33.18l27.56-9Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.06,428.38a2.29,2.29,0,0,0-3-.59,2.2,2.2,0,0,0-.61,3,2.42,2.42,0,0,0,3.19.61,2.29,2.29,0,0,0,.29-3.16",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.36,425.91l4.28-1.58,17,51.33s-.16,2.73-1.92,3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.32,446.31c-.26.08-.84-1.17-2.14-2.13s-2.62-1.25-2.61-1.52,1.65-.44,3.19.76S219.58,446.27,219.32,446.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.06,452.68c-.23.15-1.08-.8-2.49-1.28s-2.65-.31-2.74-.57,1.32-1,3.06-.33S219.3,452.59,219.06,452.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.58,458.25c-.14-.21,1-1,2.67-.9s2.66,1.15,2.48,1.34-1.2-.28-2.56-.38S213.7,458.5,213.58,458.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.38,443.56c-.28,0-.35-1.33-1-2.75s-1.51-2.39-1.34-2.61,1.49.54,2.21,2.23S225.63,443.62,225.38,443.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.19,440c-.11,0-.64-.92-1-2.65a12.94,12.94,0,0,1-.16-3.08,13.67,13.67,0,0,1,.25-1.82,3.52,3.52,0,0,1,.33-1,1.19,1.19,0,0,1,1.33-.62,1.5,1.5,0,0,1,1,.91,3.78,3.78,0,0,1,.23,1,9.86,9.86,0,0,1-.67,4.88c-.69,1.64-1.5,2.41-1.58,2.34s.46-1,.94-2.57a11.29,11.29,0,0,0,.47-2.84,10.89,10.89,0,0,0-.09-1.69c-.06-.61-.23-1.09-.53-1.14-.11,0-.15,0-.28.16a3.25,3.25,0,0,0-.24.76,15.09,15.09,0,0,0-.28,1.68,16.16,16.16,0,0,0,0,2.92A20.71,20.71,0,0,1,231.19,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.69,439.81c-.07-.07.67-.92,2.3-1.63a9.32,9.32,0,0,1,3-.7,9.76,9.76,0,0,1,1.85.09,2.32,2.32,0,0,1,1.95,1.2,1.28,1.28,0,0,1-.33,1.37,3.58,3.58,0,0,1-.87.63,6.29,6.29,0,0,1-1.78.65,6.4,6.4,0,0,1-3.15-.13c-1.74-.53-2.44-1.49-2.36-1.55a20.61,20.61,0,0,0,2.52.9,6.53,6.53,0,0,0,2.8-.08,5.8,5.8,0,0,0,1.51-.6c.53-.29.9-.67.77-.86s-.68-.55-1.21-.6a9.65,9.65,0,0,0-1.67-.14,10.09,10.09,0,0,0-2.83.46C231.65,439.31,230.78,439.94,230.69,439.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.68,403.65l41,19-23.4,51.13c-4.75-2.53-2.45-33.47-2.45-33.47l-26.77-11.11Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.85,423.5a2.3,2.3,0,0,1,3-.35,2.2,2.2,0,0,1,.37,3,2.42,2.42,0,0,1-3.22.36,2.29,2.29,0,0,1,0-3.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.68,422.67l-4.14-1.92-20.93,49.84s-.05,2.74,1.67,3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.19,441c.26.1.94-1.1,2.31-2s2.71-1,2.72-1.31-1.61-.56-3.24.51S285.94,441,286.19,441Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,447.41c.21.17,1.13-.72,2.58-1.08s2.67-.1,2.77-.35-1.23-1.06-3-.57S285.72,447.3,286,447.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,453.4c.16-.21-.93-1.12-2.59-1.11s-2.74.94-2.58,1.14,1.22-.19,2.59-.18S290.84,453.63,291,453.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.37,437.83c.28,0,.46-1.31,1.2-2.67s1.69-2.27,1.54-2.5-1.53.43-2.38,2S280.12,437.86,280.37,437.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,433.83c.11.05.71-.86,1.16-2.56a12.66,12.66,0,0,0,.41-3.06,14.58,14.58,0,0,0-.11-1.83,3.43,3.43,0,0,0-.25-1.05,1.2,1.2,0,0,0-1.28-.72,1.52,1.52,0,0,0-1.07.83,3.65,3.65,0,0,0-.3,1,9.91,9.91,0,0,0-.19,1.84,10.11,10.11,0,0,0,.47,3.07,4.83,4.83,0,0,0,1.39,2.46c.14-.08-.38-1-.73-2.64a11.4,11.4,0,0,1-.25-2.87,11.23,11.23,0,0,1,.22-1.68c.11-.6.32-1.07.62-1.1.12,0,.16,0,.26.19a2.82,2.82,0,0,1,.18.77,14.91,14.91,0,0,1,.16,1.71,16,16,0,0,1-.19,2.91A21.8,21.8,0,0,0,274.86,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.37,433.67c.08-.07-.59-1-2.16-1.81a9.19,9.19,0,0,0-3-.93,9.39,9.39,0,0,0-1.85-.06,2.34,2.34,0,0,0-2,1,1.33,1.33,0,0,0,.22,1.4,3.58,3.58,0,0,0,.82.69,6.08,6.08,0,0,0,1.73.79,6.41,6.41,0,0,0,3.14.12c1.79-.39,2.56-1.3,2.48-1.36a21.48,21.48,0,0,1-2.59.69,6.39,6.39,0,0,1-2.77-.29,5.83,5.83,0,0,1-1.46-.72c-.51-.33-.85-.74-.7-.91s.72-.5,1.24-.52a9.39,9.39,0,0,1,1.68,0,10,10,0,0,1,2.79.67C274.46,433.1,275.27,433.79,275.37,433.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.75,371.34s35.31-13.19,48.31-11.48c7.27,1,18.63,6.5,19.5,15.82s-1.41,21.77-14,27.84-62.72,28.57-74.63,32-41.63,11.58-41.63,11.58L216.05,415s61.57-21.32,64.82-23.71,11.48-5.63,11.48-5.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,375.72l.25-.07.71-.21c.62-.19,1.54-.46,2.75-.75a33.17,33.17,0,0,1,4.42-.77,32.7,32.7,0,0,1,5.94,0,34,34,0,0,1,7.07,1.35,24.53,24.53,0,0,1,3.73,1.45l3.84,1.88c5.29,2.52,11.18,5.11,17.47,7.59,12.58,5,24.66,7.44,33.27,9.39,4.32,1,7.82,1.74,10.22,2.32l2.78.65.72.17.25,0-.24-.08-.72-.2c-.62-.17-1.55-.43-2.75-.73-2.4-.61-5.88-1.44-10.2-2.43-8.6-2-20.65-4.46-33.19-9.48-6.28-2.48-12.17-5.05-17.46-7.56L192,376.43a24.92,24.92,0,0,0-3.79-1.45,33.91,33.91,0,0,0-7.13-1.32,32.84,32.84,0,0,0-6,0,31.87,31.87,0,0,0-4.44.84c-1.2.31-2.12.6-2.73.81l-.7.26A1.13,1.13,0,0,0,167,375.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.85,371.06c0,.06,1.08-.13,2.81-.32a43.85,43.85,0,0,1,6.77-.19,43.2,43.2,0,0,1,6.73.89c1.7.36,2.74.66,2.75.6a3.26,3.26,0,0,0-.7-.28,19.87,19.87,0,0,0-2-.58,35.42,35.42,0,0,0-13.6-.7c-.86.12-1.56.25-2,.37A3.46,3.46,0,0,0,168.85,371.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.61,380.68c0,.06,1-.7,2.71-1.75a36.1,36.1,0,0,1,14.53-5.13c2-.24,3.22-.27,3.21-.34a4.27,4.27,0,0,0-.87,0,23.15,23.15,0,0,0-2.37.11,32.27,32.27,0,0,0-14.65,5.17c-.83.56-1.49,1-1.92,1.4A3.79,3.79,0,0,0,304.61,380.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89,428.65l-.28.11-.8.34c-.71.28-1.74.77-3.12,1.3-2.75,1.09-6.82,2.59-12,4.3-10.43,3.41-25.43,7.75-43.37,12.27l.21.11c-3.35-9.28-7-19.53-10.92-30.3l-.11.24L230,411.47l74.81-30.79h0v0c3.05-3.22,5.85-6.06,8.48-8.36a56.71,56.71,0,0,1,7.1-5.35,53.66,53.66,0,0,1,4.87-2.72l1.31-.61.44-.22-.45.19-1.33.58a49.86,49.86,0,0,0-4.91,2.66,56.24,56.24,0,0,0-7.16,5.32c-2.65,2.29-5.47,5.12-8.53,8.33l0,0c-18.23,7.48-45,18.46-74.85,30.67l-13.52,5.56-.17.07.06.17c3.9,10.77,7.6,21,10.95,30.29l.05.14.16,0c17.94-4.56,32.92-8.95,43.34-12.41,5.21-1.75,9.27-3.27,12-4.4,1.37-.54,2.4-1.05,3.1-1.35l.79-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,258.8s-10.16,5.86-12.22,12.74c-1.26,4.18-10.74,57.63-12.24,68.17s1.66,18.35,6.16,21.85,18.12,8.15,18.12,8.15l19.17,6.21,5.49-14-18.24-26.21,1.76-17.66Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.59,249.57l6.34-4.68s8.26,8.45,17.75,7.45,15.11-8.26,15.11-8.26l28.3,5.77h0c1.9.38,5.36,1.58,8.67,6.31,3.7,5.28,21.21,28.68,21.21,28.68h12.26a9.12,9.12,0,0,1,8.06,4.86c2.09,4,4.6,9.32,4.36,11.53-.42,3.73.3,14-4.7,17.18-1.59,1-7.28,4.06-11.68,3.86-6.51-.31-14.07-3.7-18.42-6.74-3.69-2.58-12.26-11.49-15.56-15v.05l-2.12,74.24L215,372.74,199.6,258.8S218.84,249.57,219.59,249.57Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.55,269.46c-.1,0-.29,9.2-.43,20.55s-.16,20.55-.05,20.55.3-9.19.43-20.55S291.66,269.46,291.55,269.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.62,329.47s.63.1,1.75.31a21.45,21.45,0,0,1,4.59,1.47,29.5,29.5,0,0,1,6.12,3.69,53.18,53.18,0,0,1,6.45,6c2.12,2.29,4.06,4.56,5.88,6.57a69.63,69.63,0,0,0,5.05,5.15,35.94,35.94,0,0,0,3.8,3c.47.34.86.56,1.11.72a2.18,2.18,0,0,0,.4.22,1.57,1.57,0,0,0-.36-.28c-.24-.19-.61-.43-1.06-.78a41.74,41.74,0,0,1-3.71-3.12c-1.49-1.39-3.17-3.16-5-5.18s-3.73-4.3-5.86-6.6a51.59,51.59,0,0,0-6.52-6,28.88,28.88,0,0,0-6.22-3.66,19.78,19.78,0,0,0-4.67-1.36,11.72,11.72,0,0,0-1.32-.15A2,2,0,0,0,190.62,329.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.94,324.44c0,.07,1.12.23,2.89.72A26.72,26.72,0,0,1,204,332.4c1.28,1.32,2,2.24,2,2.2a3,3,0,0,0-.43-.68,16.89,16.89,0,0,0-1.38-1.71,24.26,24.26,0,0,0-12.28-7.31,16.13,16.13,0,0,0-2.16-.4A4,4,0,0,0,188.94,324.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M327,311.41c-3.93,1.07-8.65-4.58-12.22-8.12-1.85-1.84-3.78-3.8-4.46-6.32a10,10,0,0,1,.61-6.33,23.91,23.91,0,0,1,2.61-5.08c-.32,3.05-1.08,7.73-.05,11.56.86,3.19,2.88,5.74,5,8.15s5,5.23,8.48,6.14"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M310.24,308.18c.08,0-.38-1.3-.75-3.43a27.29,27.29,0,0,1-.36-3.77,29.2,29.2,0,0,1,.32-4.62,28.6,28.6,0,0,1,1.12-4.49,26.75,26.75,0,0,1,1.51-3.48c1-1.91,1.83-3,1.77-3a4,4,0,0,0-.61.73,8.23,8.23,0,0,0-.63.91,14.28,14.28,0,0,0-.77,1.26,24.55,24.55,0,0,0-1.6,3.48,27,27,0,0,0-1.17,4.55,27.63,27.63,0,0,0-.29,4.69,24,24,0,0,0,.45,3.81c.09.54.23,1,.34,1.44a10.81,10.81,0,0,0,.32,1.06A6.08,6.08,0,0,0,310.24,308.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,247c0,.1.82.61,1.73,1.42S259,250,259,249.93a5.59,5.59,0,0,0-3.34-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,251.44c-.08.08.66.88,1.26,2.06s.83,2.25.95,2.24a4.22,4.22,0,0,0-.61-2.41A4.08,4.08,0,0,0,248,251.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.76,256.09a13.2,13.2,0,0,0,.85-2.21,11.05,11.05,0,0,0,.75-2.25,8.7,8.7,0,0,0-1.6,4.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.25,252.07c.11,0,.4-1.27,1.24-2.64s1.84-2.23,1.76-2.32a5.11,5.11,0,0,0-2.08,2.13A5.22,5.22,0,0,0,226.25,252.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.82,276.11c-.1,0,1.15,10.16,2.81,22.65s3.07,22.61,3.18,22.6-1.15-10.16-2.81-22.65S201.93,276.1,201.82,276.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,292.53a4.94,4.94,0,0,0,0,1.05,9.34,9.34,0,0,0,.15,1.22c.05.24.09.49.13.76s.14.54.22.83a22,22,0,0,0,1.46,4,27.45,27.45,0,0,0,2.72,4.43,23.9,23.9,0,0,0,3.63,3.73,15.2,15.2,0,0,0,3.64,2.19c.28.12.54.24.8.33l.74.21.65.18c.2,0,.39.05.56.07a6.64,6.64,0,0,0,1,.09,19.32,19.32,0,0,1-3.69-1.12,16.56,16.56,0,0,1-3.52-2.22,24.2,24.2,0,0,1-3.55-3.7,29,29,0,0,1-2.71-4.34,25.61,25.61,0,0,1-1.52-3.91C313.12,294,313.1,292.52,313,292.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.21,377.39c-3.15-1.52-3.86-5.6-4.18-9.08q-1.41-15.3-2.83-30.59c-.44-4.8-.65-10.27,2.73-13.7,3.09-3.13,8-3.32,12.39-3.31,27.15.08,51.13.88,78.28,1l-1.38,47.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,329l-2.89,55.09a4,4,0,0,1-4,3.78l-87.74.16a4,4,0,0,1-4-3.8l-3.35-54.16c-.11-2.24,1.49-5.24,3.77-5.28h94.17A4,4,0,0,1,302.3,329Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,329a1.57,1.57,0,0,0,0-.2,3.72,3.72,0,0,0,0-.62,4,4,0,0,0-2.51-3.14,5.15,5.15,0,0,0-2.12-.3l-5.33,0-34-.06-50.43-.05h-3.58a3.17,3.17,0,0,0-1.81.47,4.65,4.65,0,0,0-1.34,1.31,6.29,6.29,0,0,0-1.1,3.55c.07,1.23.15,2.47.22,3.71.3,5,.62,10,.93,15.17.64,10.31,1.3,21,2,31.91l.13,2c.06.69.05,1.35.17,2.07a4.2,4.2,0,0,0,2.64,3.1,5.27,5.27,0,0,0,2.06.28h6l15.75,0,29.78-.07,26.95-.06,6.22,0h1.52A13,13,0,0,0,296,388a4.18,4.18,0,0,0,3.61-4.23c.05-1,.1-1.9.15-2.84.1-1.88.19-3.71.28-5.5.73-14.33,1.32-25.93,1.72-34,.2-4,.35-7.11.45-9.23.05-1.05.09-1.85.11-2.4s0-.82,0-.82l-.06.82c0,.55-.08,1.35-.14,2.4-.12,2.12-.3,5.22-.52,9.23-.44,8-1.07,19.61-1.85,33.94-.09,1.79-.19,3.63-.29,5.5q-.07,1.41-.15,2.85a4,4,0,0,1-.92,2.6,3.92,3.92,0,0,1-2.45,1.34,10.33,10.33,0,0,1-1.48,0H286.7l-26.95,0-29.78,0-15.75,0h-6a4.91,4.91,0,0,1-1.92-.25,3.85,3.85,0,0,1-2.41-2.83c-.11-.62-.11-1.34-.16-2l-.13-2c-.68-10.93-1.34-21.6-2-31.91-.32-5.15-.64-10.22-1-15.17-.07-1.24-.15-2.47-.22-3.7a5.94,5.94,0,0,1,1-3.34,3.26,3.26,0,0,1,2.86-1.62h3.58l50.42,0,34-.06h5.33a5,5,0,0,1,2.09.27,3.79,3.79,0,0,1,1.44,1,4,4,0,0,1,1.06,2.1A8.06,8.06,0,0,1,302.3,329Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,355.89a5.17,5.17,0,1,0,5.17-5.17A5.18,5.18,0,0,0,245.45,355.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,355.89c.05,0,0-.46.24-1.24a5.14,5.14,0,0,1,1.89-2.76,5,5,0,0,1,8,4,5,5,0,0,1-5.9,4.92,5,5,0,0,1-2.12-.92,5.14,5.14,0,0,1-1.89-2.76c-.21-.78-.19-1.24-.24-1.24a1.19,1.19,0,0,0,0,.33,4.42,4.42,0,0,0,.11.95,5.13,5.13,0,0,0,1.87,2.93,5.21,5.21,0,0,0,2.23,1,5.31,5.31,0,0,0,2.8-.21,5.19,5.19,0,0,0,2.49-1.86,5.32,5.32,0,0,0-5.29-8.39,5.2,5.2,0,0,0-2.23,1,5.15,5.15,0,0,0-1.87,2.94,4.35,4.35,0,0,0-.11.95A1.19,1.19,0,0,0,245.45,355.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.35,335.12c-.11,0-.54,9.25-1,20.67s-.69,20.69-.58,20.69.53-9.25,1-20.67S299.45,335.12,299.35,335.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.72,263.25c.51-.44-1.73-9.09-1.73-9.09s5.95-9.71,6.11-12.84-2.35-9.56-2.35-9.56l-17.08-4.39s-5.48,10.19-6.58,13.79S306,257,306,257l2.89,6.27S317.59,270.14,325.72,263.25Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.06,243.19a39.05,39.05,0,0,0,1.8-3.79c1.08-2.57,2.41-5.08,0-6.52a3.13,3.13,0,0,0-2.57-.4s.37-2.16-.92-3a2.77,2.77,0,0,0-2.53-.22s.4-3-1.45-4.33a4.51,4.51,0,0,0-4.73-.14s1.47-13.32,1.6-14c.46-2.59-.49-4.88-3.07-4.24-.95.23-1.47,1.23-2.58,5.57s-2.89,11.74-2.89,11.74-3,5.21-4.41,8-4.22,9.26-4.45,11c-.61,4.41,2,10.25,2,10.25l18.15,1S329.37,244.45,330.06,243.19Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.93,233.05a16.67,16.67,0,0,0-1.4,2l-1.44,2.19a8.81,8.81,0,0,0-.78,1.36,2.75,2.75,0,0,0-.21,1.73,1.74,1.74,0,0,0,1.14,1.35,2.3,2.3,0,0,0,1.63-.2,8.1,8.1,0,0,0,1.21-.75c.36-.26.69-.5,1-.74.59-.46,1.05-.85,1.35-1.13s.47-.45.45-.47-.75.53-2,1.39a16,16,0,0,1-2.17,1.38,2,2,0,0,1-1.37.16,1.36,1.36,0,0,1-.89-1.07,2.49,2.49,0,0,1,.18-1.5,8.83,8.83,0,0,1,.74-1.32l1.36-2.23A14.54,14.54,0,0,0,328.93,233.05Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,234.64a6.13,6.13,0,0,0-.19-2.86,6.06,6.06,0,0,0-1.13-2.62c-.1.05.41,1.21.76,2.71S313.93,234.64,314,234.64Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.85,238.53a12,12,0,0,1,6.07-3.17,22.92,22.92,0,0,1,6.92-.26c1.84.16,4,.64,4.79,2.29s-.17,3.9-1.81,4.87a9.22,9.22,0,0,1-5.57.85,23.21,23.21,0,0,0-5.7-.23",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.55,242.88s.51,0,1.43,0a37.87,37.87,0,0,1,3.89.37,15.92,15.92,0,0,0,2.73.11,7.32,7.32,0,0,0,3.06-.77,4.66,4.66,0,0,0,2.27-2.64,3.64,3.64,0,0,0,.13-1.89,3.21,3.21,0,0,0-1-1.67,6.5,6.5,0,0,0-3.49-1.36,32.2,32.2,0,0,0-3.45-.21,17.25,17.25,0,0,0-5.77.88,11.67,11.67,0,0,0-3.47,1.87,9.72,9.72,0,0,0-.79.71c-.17.18-.25.28-.24.29s.38-.35,1.12-.89a12.5,12.5,0,0,1,3.46-1.73,18.07,18.07,0,0,1,5.69-.78,34.07,34.07,0,0,1,3.4.23,6.16,6.16,0,0,1,3.28,1.27,2.88,2.88,0,0,1,.89,1.48,3.24,3.24,0,0,1-.12,1.69,4.32,4.32,0,0,1-2.08,2.44,7.09,7.09,0,0,1-2.91.77,17.93,17.93,0,0,1-2.68-.07,29,29,0,0,0-3.92-.25,9.1,9.1,0,0,0-1.06.1C311.67,242.83,311.55,242.86,311.55,242.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.8,233.26c-1.91,2.9-3.6,6.09-5.21,9.17a5.65,5.65,0,0,1-1.82,2.37c-.69.42-2.4-.35-3.16-.61l5.24-11.93",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.85,232.26a5.74,5.74,0,0,0-.46.89l-1.16,2.5c-1,2.12-2.31,5.1-3.79,8.46l-.09.19.2.07a17.78,17.78,0,0,0,1.83.62,4.17,4.17,0,0,0,.8.12,1.3,1.3,0,0,0,.43-.05,1,1,0,0,0,.39-.19,4.05,4.05,0,0,0,1.06-1.13c.54-.85.92-1.7,1.35-2.48.82-1.59,1.57-3,2.23-4.19s1.2-2.13,1.59-2.78a8,8,0,0,0,.57-1,6.23,6.23,0,0,0-.7,1c-.42.63-1,1.55-1.69,2.72s-1.47,2.58-2.31,4.16c-.44.78-.84,1.65-1.35,2.44a3.63,3.63,0,0,1-1,1,1.57,1.57,0,0,1-1.32.06,18.13,18.13,0,0,1-1.8-.61l.11.26c1.48-3.38,2.77-6.37,3.68-8.52l1.05-2.55A5.84,5.84,0,0,0,323.85,232.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.27,228.71q-2.53,6.34-5.06,12.68a8.81,8.81,0,0,1-1.36,2.55,3,3,0,0,1-2.55,1.11,3,3,0,0,1-2.24-2.93,9.53,9.53,0,0,1,.94-3.85,79.2,79.2,0,0,0,3.63-11.86",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.63,226.41a1.49,1.49,0,0,0-.13.38l-.3,1.12c-.26,1-.64,2.38-1.17,4.1s-1.23,3.75-2.1,6a12.7,12.7,0,0,0-1.06,3.63,3.94,3.94,0,0,0,.39,2,2.88,2.88,0,0,0,1.52,1.49,2.57,2.57,0,0,0,2.12-.17,4,4,0,0,0,1.49-1.41,21.77,21.77,0,0,0,1.53-3.44c.87-2.21,1.65-4.2,2.31-5.9l1.53-4c.16-.44.29-.8.39-1.09a1.73,1.73,0,0,0,.12-.39,1.34,1.34,0,0,0-.19.36c-.12.29-.28.64-.46,1.07L323,234.08c-.68,1.69-1.49,3.67-2.38,5.87a22.39,22.39,0,0,1-1.52,3.37,3.66,3.66,0,0,1-1.35,1.27,2.18,2.18,0,0,1-1.81.16,2.58,2.58,0,0,1-1.32-1.3,3.55,3.55,0,0,1-.35-1.83,11.9,11.9,0,0,1,1-3.52c.86-2.23,1.52-4.28,2-6s.85-3.16,1.07-4.14c.1-.5.18-.88.23-1.14A1.51,1.51,0,0,0,318.63,226.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9,294.25c-.46-1.68-12-35.81-12-35.81l-19.08-2.28,7.8,29.4s-1.21,7.47,0,11.89,11,16.45,16,13.56S337.35,295.93,336.9,294.25Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.58,253.14a2.22,2.22,0,0,0,1.09-.14,6.1,6.1,0,0,0,3.83-3.51,2.26,2.26,0,0,0,.23-1.07,9.87,9.87,0,0,1-2,3A9.62,9.62,0,0,1,313.58,253.14Z",
    style: {
      fill: "#eb996e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.c7f3d36ed5366777423f92a2a717f1c2.svg";
export { ForwardRef as ReactComponent };